function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  role: "img"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 20,
  height: 20,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h20v20H0z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m12 14-1.062-1.062 2.187-2.188H4v-1.5h9.125l-2.187-2.187L12 6l4 4z"
})));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-arrow-start-slot.svg";
export { SvgComponent as ReactComponent };